import { BASE_APIURL } from "../../utils/helpers";

// Resolve API base URL dynamically: if running on localhost, use local backend port 8000
const API_BASE = 
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://localhost:8000"
    : (BASE_APIURL || "http://localhost:8000");

export const TOXBOX_API_BASE = `${API_BASE}/api/blogs/external`;
export const TOXBOX_PAGE_SIZE = 9;
